import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    width: 220px;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color:#404040;
    border: ${props => props.isCurrent ? props.isActive ? "7px solid var(--green)" : "10px solid var(--red)" : "#999"};
    border-radius: 2px;
    transition: transform 800ms ease, background-color, 800ms ease;
    cursor: pointer;
    position: relative;

     i.video-cta {
      font-size: 24px;
      color: var(--blue);
      position: absolute;
      bottom: 8px;
      right: 8px;
      cursor: pointer ;
    }

    i.video-cta:hover {
      color: var(--red);
      font-size: 28px;
    }
    /* opacity: ${props =>  props.isActive ? 1 : 0.5}; */

    :hover {
      background-color: #999;
      transform: scale(1.05);
      border-width: 7px;
      border-style: solid;
      border-color: ${props => props.isActive ? 'var(--green)' : 'var(--red)'}
    }

    img.course-icon {
        width: 180px;
    opacity: ${props =>  props.isActive ? 1 : 0.25};
    }

`


// WEBPACK FOOTER //
// ./src/common/CourseDisplays/SearchFilterCourseItem.styles.ts